module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step2-pict02-full-1704053804f2f8677141f253877aa1ac.jpg";